import { Controller } from "@hotwired/stimulus"
import { Carousel } from "bootstrap"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["column", "gallery", "control"]

  connect() {
    this.noSlide = false
  }

  // Bound here rather than with a data-action: the gallery partial is also rendered outside a modal
  // gallery, where an action naming this controller would have no controller to reach. Removed again on
  // disconnect, so a gallery that connects again does not carry a second listener.
  galleryTargetConnected(gallery) {
    gallery.addEventListener("slide.bs.carousel", this.#preventSlideWhileZoomed)
  }

  galleryTargetDisconnected(gallery) {
    gallery.removeEventListener("slide.bs.carousel", this.#preventSlideWhileZoomed)
  }

  #preventSlideWhileZoomed = event => {
    if (this.noSlide) {
      event.preventDefault()
    }
  }

  to({ params }) {
    new Carousel(this.galleryTarget).to(params.index)
  }

  showAllImages(event) {
    this.columnTargets.forEach(column => {
      column.classList.remove(this.hiddenClass)
    })
    event.target.remove()
  }

  toggleNavigation(event) {
    const { zoomLevel } = event.detail

    this.noSlide = zoomLevel > 1

    this.controlTargets.forEach(target => {
      target.classList.toggle(this.hiddenClass, this.noSlide)
    })
  }
}
